import { render, staticRenderFns } from "./GlobalFloatingSpinner.vue?vue&type=template&id=4e31363a&scoped=true&"
import script from "./GlobalFloatingSpinner.vue?vue&type=script&lang=js&"
export * from "./GlobalFloatingSpinner.vue?vue&type=script&lang=js&"
import style0 from "./GlobalFloatingSpinner.vue?vue&type=style&index=0&id=4e31363a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e31363a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VFadeTransition,VIcon,VProgressCircular})
